import React, { useState, useEffect } from 'react';
import '../Styles/Headers.css';

function Header({ heading, subheading, name }) {
  const [opacity, setOpacity] = useState(100);

  useEffect(() => {
    function handleScroll() {
      const header = document.querySelector(`.${name}.header_group`);
      const screenHeight = window.innerHeight;
      const headerRect = header.getBoundingClientRect();
      const headerPosition = headerRect.top + headerRect.height / 2;
      const distanceFromMiddle = Math.abs(screenHeight / 2 - headerPosition);
      const maxDistance = screenHeight / 2;
      const opacity = 1 - (distanceFromMiddle / maxDistance);
      setOpacity(opacity);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`header_group ${name}`}>
      <h2 className="subheading" style={{ opacity }}>{subheading}</h2>
      <h1 className="heading" style={{ opacity }}>{heading}</h1>
    </div>
  );
}

export default Header;